import { render } from "./arrayOfObjects.vue?vue&type=template&id=84e7f2a0&scoped=true"
import script from "./arrayOfObjects.vue?vue&type=script&lang=js"
export * from "./arrayOfObjects.vue?vue&type=script&lang=js"

import "./arrayOfObjects.vue?vue&type=style&index=0&id=84e7f2a0&lang=css"
import "./arrayOfObjects.vue?vue&type=style&index=1&id=84e7f2a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84e7f2a0"]])

export default __exports__